/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Ballot } from '@src/app/model/ballot';
import { BallotService } from '@src/app/modules/social/ballot-page/ballot.service';
import { BallotPageNavRoute } from '@src/app/routes/app-router';

import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';

@Component({
    selector: 'app-ballot-widget',
    imports: [RouterLink],
    templateUrl: './ballot-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class BallotWidgetComponent  implements IWidget, OnInit {
  @Input() chosenWidget: ChosenWidget;
  title = $localize `Recent Votes & Meetings`;
  host: ElementRef<Element> = inject(ElementRef);
  options: { name: string; action: () => void; }[];
  ballotSvc = inject(BallotService)
  maxItems = 5;

  routerLink = BallotPageNavRoute.getListRouterLink();

  data: Ballot[] = [];

  ngOnInit(): void {
    const parms = new HttpParams().set('_limitTo', this.maxItems).set('_sortDesc', 'updatedAt');
    this.ballotSvc.get<Ballot>(false, parms).subscribe( data => {
      this.data = data;
    })
  }

  getNavRoute(p: Ballot) {
    return [BallotPageNavRoute.getIdUrl(p.id, p.teamId)];
  }
}
